import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { createEnum } from "../common/zod-util";

export enum OrderEditKind {
  ADDRESS = "address",
  CANCEL = "cancel",
  VARIANT_CHANGE = "variant_change",
  ADD_PRODUCT = "add_product",
  REMOVE_PRODUCT = "remove_product",
  DISCOUNT = "discount",
  ADD_QUANTITY = "add_quantity",
  REMOVE_QUANTITY = "remove_quantity",
}

export enum OrderEditSource {
  "SUPPORT_AI" = "support_ai",
  "SUPPORT_SELF_SERVICE" = "support_self_service",
  "CUSTOMER_PORTAL_SELF_SERVICE" = "customer_portal_self_service",
}

export enum LineItemDiffChangeType {
  ADDED = "added",
  REMOVED = "removed",
  QUANTITY_ADDED = "quantity_added",
  QUANTITY_REMOVED = "quantity_removed",
}

const LineItemDiffSchema = z.object({
  lineItemId: z.string(),
  variantId: z.string().nullish(),
  productTitle: z.string().nullish(),
  variantTitle: z.string().nullish(),
  sku: z.string().nullish(),
  quantityBefore: z.number(),
  quantityAfter: z.number(),
  changeType: createEnum(LineItemDiffChangeType),
});

export const OrderEditSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  kind: createEnum(OrderEditKind),
  source: createEnum(OrderEditSource),
  redoOrderId: zExt.objectId().nullish(),
  customerName: z.string(),
  orderNumber: z.string(),
  createdAt: z.date(),
  orderCreatedAt: z.date(),
  totalPriceBefore: z.string().nullish(),
  totalPriceAfter: z.string().nullish(),
  lineItemDiff: z.array(LineItemDiffSchema).min(1).nullish(),
});

export type OrderEdit = z.infer<typeof OrderEditSchema>;
export type LineItemDiff = z.infer<typeof LineItemDiffSchema>;
